import { Pipe, PipeTransform } from '@angular/core';

// Wraps the matched substring of `text` in <mark>. Escapes both the term (for the
// regex) and the text (for HTML) so it is safe to bind via [innerHTML].
@Pipe({ name: 'ghlHighlight', standalone: true })
export class HighlightPipe implements PipeTransform {
  transform(text: string, term: string): string {
    const safeText = this.escapeHtml(text || '');
    const q = (term || '').trim();
    if (!q) {
      return safeText;
    }

    const pattern = new RegExp(`(${this.escapeRegExp(this.escapeHtml(q))})`, 'ig');
    return safeText.replace(pattern, '<mark>$1</mark>');
  }

  private escapeHtml(value: string): string {
    return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  private escapeRegExp(value: string): string {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
}
